import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full min-h-full flex bg-gray-100" }
const _hoisted_2 = { class: "w-full grid bg-white overscroll-none" }
const _hoisted_3 = { class: "w-full grid grid-cols-1 sm:grid-cols-2 gap-2 pt-10 px-10" }
const _hoisted_4 = { class: "flex flex-col text-left" }
const _hoisted_5 = { class: "text-xl font-bold mt-2 sm:mt-10" }
const _hoisted_6 = { class: "flex flex-col items-end md:pt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_clients_list = _resolveComponent("clients-list")!
  const _component_warning = _resolveComponent("warning")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.countDeptorcases) + " " + _toDisplayString(_ctx.countDeptorcases === 0 || _ctx.countDeptorcases > 1 ? 'Reclamaciones' : 'Reclamación'), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_router_link, {
            to: "/debt",
            class: _normalizeClass(["md:w-60 w-full mt-4 py-2 md:px-6 text-white rounded-md border-2 font-bold", `bg-${$setup.colors.primary}-500 hover:bg-${$setup.colors.primary}-600`])
          }, {
            default: _withCtx(() => [
              _createTextVNode("Nueva reclamación")
            ]),
            _: 1
          }, 8, ["class"])
        ])
      ]),
      _createVNode(_component_clients_list, {
        onOnFire: $setup.setCountDeptorCases,
        idClient: _ctx.idClient,
        type: 'change'
      }, null, 8, ["onOnFire", "idClient"]),
      _createVNode(_component_warning, { type_: 'change' })
    ])
  ]))
}